import { useHead, useJsonld } from '#imports'
import { useGlobalStore } from '~/stores'

export default function useSeo() {
  const globalStore = useGlobalStore()

  const title = `人才發展｜${import.meta.env.VITE_WEBSITE_TITLE}`
  const description = globalStore.seoDescriptions.career
  const url = `${import.meta.env.VITE_DOMAIN}/talent-development`

  globalStore.setBreadcrumbs([{ title: '人才發展', isActive: true, url: '/talent-development' }])

  useSeoMeta({
    title: title,
    ogTitle: title,
    description: description,
    ogDescription: description
    // ogImage: seo.og_image?.link,
    // keywords: seo.meta_keywords?.join(',')
  })

  useHead({
    link: [
      {
        rel: 'canonical',
        href: url
      }
    ]
  })

  useJsonld({
    '@context': 'https://schema.org',
    '@graph': [
      {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '首頁',
            item: import.meta.env.VITE_DOMAIN
          },
          {
            '@type': 'ListItem',
            position: 1,
            name: '人才發展',
            item: url
          }
        ]
      }
    ]
  })
}
